<template>
  <div class="aboutUsPage">
    <head-top></head-top>
    <div class="banner">
      <h3>关于商鼎云</h3>
      <p>商鼎云持续在电商领域深耕</p>
    </div>
    <div class="aboutUsTitle">
      <span>公司介绍</span>
      <p>Company introduction</p>
    </div>
    <div class="introductionBox">
      商鼎云技术（深圳）集团有限公司正式成立于2015，是一家以提供专业的移动应用开发为主的专业公司。公司有着互联网及移动互联网10多年的从业经验，凭着在这个领域丰富的行业经验和强大的研发团队，为我们的客户提供有价值的产品和服务。
    </div>
    <section class="introductionTypeBox">
      <div>
        <span class="icon">&#xe697;</span>
        <p>我们沉浸于用户体验帮您挖掘和创新更大商机的可能</p>
      </div>
      <div>
        <span class="icon">&#xe696;</span>
        <p>服务思维下的商业设计撇弃浮夸去直达共同的目标</p>
      </div>
      <div>
        <span class="icon">&#xe6b2;</span>
        <p>精益合作和分享的态度让我们鼎力相助你的梦想</p>
      </div>
    </section>
    <section class="courseBox">
      <div class="aboutUsTitle">
        <span>发展历程</span>
        <p>DEVELOPMENT PATH</p>
      </div>
      <div class="courseInfoBox">
        <div>
          <div>
            <span>2015.05</span>
            <p>KARLE IT 技术网V1.0基于WEB发布</p>
          </div>
          <div>
            <span>2015.10</span>
            <p>KARLE IT 技术网V2.0基于WEB发布</p>
          </div>
          <div>
            <span>2016.03</span>
            <p>KARLE IT 使用免费用户达到30000人，收费问答社区突破5000人次</p>
          </div>
          <div>
            <span>2016.11</span>
            <p>SDCC 2016中国软件开发者大会KARLE IT 技术团队应邀参加并做技术分享</p>
          </div>
          <div>
            <span>2017.10</span>
            <p>与猪八戒、一品威客达成战略合作</p>
          </div>
          <div>
            <span>2018.8</span>
            <p>中国区块链技术应用大会，获得区块链技术应用奖</p>
          </div>
        </div>
      </div>
    </section>
    <div class="aboutUsTitle">
      <span>我们的誓言</span>
      <p>Our Promise</p>
    </div>
    <section class="teamBox">
      <p>我们是一群热爱创意与技术的人，我们的成员由市场营销、交互设计、视觉设计、前端开发、后端开发、技术架构的专家组成。
        信任，积极，责任，对细节的尊重是我们的关键词。</p>
    </section>
    <foot-guide></foot-guide>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import "src/style/mixin";
.aboutUsPage {
  background-color: #fff;
}
.banner {
  background-image: url("https://qn.kemean.cn/upload/201809/06/4a533e40b153420087eb0ab3fd2cc4f2");
}
@media screen and (min-width: 1200px) {
  .aboutUsTitle {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0;
    span {
      font-size: 48px;
      color: #333333;
    }
    p {
      font-size: 18px;
      color: rgba(51, 51, 51, 0.5);
    }
  }
  .introductionBox {
    max-width: 900px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    line-height: 180%;
    color: #999999;
    font-size: 16px;
  }
  .introductionTypeBox {
    max-width: 1200px;
    width: 100%;
    margin: 59px auto 0 auto;
    display: flex;
    justify-content: space-around;
    padding-bottom: 100px;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 260px;
      .icon {
        width: 160px;
        height: 160px;
        background-color: #f0f0f0;
        border-radius: 50%;
        text-align: center;
        line-height: 160px;
        font-size: 47px;
        color: #666666;
      }
      p {
        margin-top: 30px;
        text-align: center;
        font-size: 18px;
        color: #666666;
      }
    }
  }
  .courseBox {
    width: 100%;
    margin: 0 auto;
    background-image: url("https://qn.kemean.cn/upload/201809/06/54027b72d3674e23a6a5276cce4dc0cb");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    padding-top: 50px;
    padding-bottom: 110px;
    .aboutUsTitle {
      span {
        color: #fff;
      }
      p {
        color: #fff;
        opacity: 0.5;
      }
    }
    .courseInfoBox {
      max-width: 1175px;
      width: 100%;
      margin: 0 auto;
      > div {
        position: relative;
        height: 306px;
        &::after {
          content: "";
          position: absolute;
          top: 154px;
          right: 0px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #fff;
        }
        > div {
          position: absolute;
          border-left: 1px solid #fff;
          height: 160px;
          padding: 30px 25px;
          &:nth-child(1) {
            left: 0px;
            width: 335px;
          }
          &:nth-child(2) {
            left: 172px;
            width: 330px;
          }
          &:nth-child(3) {
            left: 335px;
            width: 400px;
          }
          &:nth-child(4) {
            left: 502px;
            width: 400px;
          }
          &:nth-child(5) {
            left: 732px;
            right: 0px;
          }
          &:nth-child(6) {
            left: 932px;
            width: 222px;
          }
          &::before {
            content: "\e604";
            font-family: "iconfont";
            position: absolute;
            color: #fff;
            font-size: 24px;
            left: -12px;
          }
          &:nth-of-type(odd) {
            border-bottom: 2px solid #fff;
            top: 0px;
            &::before {
              bottom: -12px;
            }
          }
          &:nth-of-type(even) {
            top: 160px;
            &::before {
              top: -12px;
            }
          }
          span {
            font-size: 20px;
            color: #ffffff;
            opacity: 0.4;
            line-height: 180%;
          }
          p {
            font-size: 16px;
            color: #ffffff;
            line-height: 180%;
          }
        }
      }
    }
  }
  .teamBox {
    padding: 0vw 0px 6vw 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    .homeTitle {
      span {
        color: #333333;
      }
      p {
        color: rgba(51, 51, 51, 0.5);
      }
    }
    .teamPeople {
      display: flex;
      justify-content: center;
      margin-bottom: 40px;
      flex-wrap: wrap;
      border-bottom: 1px solid #ddd;
      padding-bottom: 10px;
      .teamPeopleList {
        width: 180px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;
        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
        span {
          display: block;
          margin-top: 15px;
          font-size: 16px;
          color: #666;
        }
      }
    }
    > p {
      max-width: 1100px;
      width: 80%;
      text-align: center;
      font-size: 18px;
      line-height: 2;
    }
  }
}
@media screen and (min-width: 750px) and (max-width: 1200px) {
  .aboutUsTitle {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4vw 0;
    span {
      font-size: 4.5vw;
      color: #333333;
    }
    p {
      font-size: 1.6vw;
      color: rgba(51, 51, 51, 0.5);
    }
  }
  .introductionBox {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    line-height: 180%;
    color: #999999;
    font-size: 1.6vw;
    padding: 0 2.5vw;
  }
  .introductionTypeBox {
    width: 100%;
    margin: 5.9vw auto 0 auto;
    display: flex;
    justify-content: space-around;
    padding-bottom: 10vw;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 33.333%;
      padding: 0 1.5vw;
      .icon {
        width: 18vw;
        height: 18vw;
        background-color: #f0f0f0;
        border-radius: 50%;
        text-align: center;
        line-height: 18vw;
        font-size: 6vw;
        color: #666666;
      }
      p {
        margin-top: 3vw;
        text-align: center;
        font-size: 1.8vw;
        color: #666666;
      }
    }
  }
  .courseBox {
    width: 100%;
    margin: 0 auto;
    background-image: url("https://qn.kemean.cn/upload/201809/06/54027b72d3674e23a6a5276cce4dc0cb");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    padding-top: 5vw;
    padding-bottom: 11vw;
    .aboutUsTitle {
      span {
        color: #fff;
      }
      p {
        color: #fff;
        opacity: 0.5;
      }
    }
    .courseInfoBox {
      padding: 0 3vw;
      width: 100%;
      > div {
        position: relative;
        height: 80vw;
        &::after {
          content: "";
          position: absolute;
          bottom: 0px;
          left: calc(50% - 5px);
          width: 1vw;
          height: 1vw;
          border-radius: 50%;
          background-color: #fff;
        }
        > div {
          position: absolute;
          width: 50%;
          max-width: 350px;
          height: 26vw;
          padding: 0 3vw;
          &:nth-child(1) {
            top: 0px;
          }
          &:nth-child(2) {
            top: 13vw;
          }
          &:nth-child(3) {
            top: 26vw;
          }
          &:nth-child(4) {
            top: 39vw;
          }
          &:nth-child(5) {
            top: 52vw;
          }
          &:nth-child(6) {
            top: 65vw;
          }
          &::before {
            content: "\e604";
            font-family: "iconfont";
            position: absolute;
            color: #fff;
            font-size: 2.4vw;
            top: 2vw;
          }
          &::after {
            content: "";
            position: absolute;
            width: 2px;
            background-color: #fff;
            height: calc(50% - 2.4vw);
            top: 4.4vw;
          }
          &:nth-of-type(odd) {
            left: calc(50% - 1px);
            &::before {
              left: -1.1vw;
            }
            &::after {
              left: 0px;
            }
          }
          &:nth-of-type(even) {
            right: calc(50% - 1px);
            text-align: right;
            &::before {
              right: -1.1vw;
            }
            &::after {
              right: 0px;
            }
          }
          span {
            font-size: 2vw;
            color: #ffffff;
            opacity: 0.4;
            line-height: 180%;
            transform: translateY(50px);
          }
          p {
            font-size: 2vw;
            color: #ffffff;
            line-height: 180%;
          }
        }
      }
    }
  }
  .teamBox {
    padding: 0vw 0px 6vw 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    .homeTitle {
      span {
        color: #333333;
      }
      p {
        color: rgba(51, 51, 51, 0.5);
      }
    }
    .teamPeople {
      display: flex;
      justify-content: center;
      margin-bottom: 40px;
      flex-wrap: wrap;
      border-bottom: 1px solid #ddd;
      padding-bottom: 10px;
      .teamPeopleList {
        width: 180px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;
        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
        span {
          display: block;
          margin-top: 15px;
          font-size: 16px;
          color: #666;
        }
      }
    }
    > p {
      max-width: 1100px;
      width: 80%;
      text-align: center;
      font-size: 18px;
      line-height: 2;
    }
  }
}
@media screen and (max-width: 750px) {
  .aboutUsTitle {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4vw 0;
    span {
      font-size: 4.5vw;
      color: #333333;
    }
    p {
      font-size: 1.6vw;
      color: rgba(51, 51, 51, 0.5);
    }
  }
  .introductionBox {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    line-height: 180%;
    color: #999999;
    font-size: 3.6vw;
    padding: 0 3vw;
  }
  .introductionTypeBox {
    width: 100%;
    margin: 8vw auto 8vw auto;
    > div {
      display: flex;
      align-items: center;
      padding: 0 3vw;
      margin-bottom: 5vw;
      .icon {
        width: 18vw;
        height: 18vw;
        background-color: #f0f0f0;
        border-radius: 50%;
        text-align: center;
        line-height: 18vw;
        font-size: 6vw;
        color: #666666;
        flex-shrink: 0;
      }
      p {
        font-size: 3.6vw;
        color: #666666;
        margin-left: 5vw;
      }
    }
  }
  .courseBox {
    width: 100%;
    margin: 0 auto;
    background-image: url("https://qn.kemean.cn/upload/201809/06/54027b72d3674e23a6a5276cce4dc0cb");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    padding-top: 5vw;
    padding-bottom: 11vw;
    .aboutUsTitle {
      span {
        color: #fff;
      }
      p {
        color: #fff;
        opacity: 0.5;
      }
    }
    .courseInfoBox {
      padding: 0 3vw;
      width: 100%;
      > div {
        position: relative;
        height: 154vw;
        &::after {
          content: "";
          position: absolute;
          bottom: 0px;
          left: calc(50% - 0.7vw);
          width: 1.5vw;
          height: 1.5vw;
          border-radius: 50%;
          background-color: #fff;
        }
        > div {
          position: absolute;
          width: 50%;
          max-width: 350px;
          height: 50vw;
          padding: 0 4.5vw;
          &:nth-child(1) {
            top: 0px;
          }
          &:nth-child(2) {
            top: 25vw;
          }
          &:nth-child(3) {
            top: 50vw;
          }
          &:nth-child(4) {
            top: 75vw;
          }
          &:nth-child(5) {
            top: 100vw;
          }
          &:nth-child(6) {
            top: 125vw;
          }
          &::before {
            content: "\e604";
            font-family: "iconfont";
            position: absolute;
            color: #fff;
            font-size: 4vw;
            top: 4vw;
          }
          &::after {
            content: "";
            position: absolute;
            width: 2px;
            background-color: #fff;
            height: calc(50% - 4vw);
            top: 8vw;
          }
          &:nth-of-type(odd) {
            left: calc(50% - 1px);
            &::before {
              left: -1.8vw;
            }
            &::after {
              left: 0px;
            }
          }
          &:nth-of-type(even) {
            right: calc(50% - 1px);
            text-align: right;
            &::before {
              right: -1.8vw;
            }
            &::after {
              right: 0px;
            }
          }
          span {
            font-size: 3.8vw;
            color: #ffffff;
            opacity: 0.4;
            line-height: 180%;
            transform: translateY(50px);
          }
          p {
            font-size: 3.6vw;
            color: #ffffff;
            line-height: 180%;
          }
        }
      }
    }
  }
  .teamBox {
    padding: 0vw 0px 6vw 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .homeTitle {
      span {
        color: #333333;
      }
      p {
        color: rgba(51, 51, 51, 0.5);
      }
    }
    .teamPeople {
      display: flex;
      justify-content: center;
      margin-bottom: 8vw;
      flex-wrap: wrap;
      border-bottom: 1px solid #ddd;
      padding-bottom: 1vw;
      .teamPeopleList {
        width: 25vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 4vw;
        img {
          width: 20vw;
          height: 20vw;
          border-radius: 50%;
        }
        span {
          display: block;
          margin-top: 1.5vw;
          font-size: 3.8vw;
        }
      }
    }
    > p {
      width: 90%;
      text-align: center;
      font-size: 3vw;
      line-height: 2;
    }
  }
}
</style>
